import { useState } from "react";
import { faqs } from "@/mocks/content";

function FaqSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50 py-14 md:py-16">
      <FaqSchema />
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.6fr] lg:gap-16">
          <div>
            <span className="mb-2 inline-flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-primary-600">
              <i className="ri-question-answer-line"></i> FAQ
            </span>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">常见问题解答</h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              关于51黑瓜的使用方式、内容原则与互动方法，这里整理了大家最常问的问题。如果还有疑问，欢迎随时联系我们。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="mailto:hello@51heigua.com"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-white transition hover:bg-primary-600"
              >
                <i className="ri-mail-line"></i>
                联系编辑部
              </a>
            </div>
          </div>

          <div className="space-y-3">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={i}
                  className={`overflow-hidden rounded-2xl border transition ${
                    isOpen ? "border-primary-200 bg-primary-50/60" : "border-background-200 bg-background-100"
                  }`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <h3 className="text-base font-medium text-foreground-950">{f.q}</h3>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition ${
                        isOpen ? "rotate-45 bg-primary-500 text-white" : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      <i className="ri-add-line"></i>
                    </span>
                  </button>
                  {isOpen && (
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}